import { RouterProvider } from 'react-router-dom';

import ThemeProvider from '@/components/ui/theme-provider';
import { Toaster } from '@/components/ui/sonner';
import { router } from '@/router';
import { AuthProvider } from '@/services/auth-context';

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <RouterProvider router={router} />
        <Toaster />
      </AuthProvider>
    </ThemeProvider>
  );
}
